const PAYMENT_EVENT_I18N_KEYS = {
  payment_attempt: "paymentEvent_payment_attempt",
  payment_rejected: "paymentEvent_payment_rejected",
  payment_pending: "paymentEvent_payment_pending",
  payment_approved: "paymentEvent_payment_approved",
  payment_cancelled: "paymentEvent_payment_cancelled",
  payment_update: "paymentEvent_payment_update",
  approved: "paymentEvent_approved",
  rejected: "paymentEvent_rejected",
  pending: "paymentEvent_pending",
  in_process: "paymentEvent_in_process",
  authorized: "paymentEvent_authorized",
  cancelled: "paymentEvent_cancelled",
  chargeback: "paymentEvent_chargeback",
  chargeback_update: "paymentEvent_chargeback_update",
  refund: "paymentEvent_refund",
  unknown: "paymentEvent_unknown",
};

const PAYMENT_PROVIDER_I18N_KEYS = {
  xpay: "paymentProvider_xpay",
  mercadopago: "paymentProvider_mercadopago",
  cielo: "paymentProvider_cielo",
  rede: "paymentProvider_rede",
  pix_itau: "paymentProvider_pix_itau",
  appmax: "paymentProvider_appmax",
  unknown: "paymentProvider_unknown",
};

function humanizeToken(value) {
  return String(value || "")
    .trim()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Rótulo amigável para event_type de passagens_pagamentos. */
export function paymentEventTypeLabel(t, eventType) {
  const key = String(eventType || "unknown").trim().toLowerCase();
  const i18nKey = PAYMENT_EVENT_I18N_KEYS[key];
  if (i18nKey) {
    return t(`passagensPage.${i18nKey}`, { defaultValue: humanizeToken(key) });
  }
  return t("passagensPage.paymentEvent_generic", {
    defaultValue: humanizeToken(key) || "Evento de pagamento",
  });
}

/** Rótulo amigável para provider (perspectiva do cliente: XPay). */
export function paymentProviderLabel(t, provider) {
  const key = String(provider || "unknown").trim().toLowerCase();
  const i18nKey = PAYMENT_PROVIDER_I18N_KEYS[key];
  if (i18nKey) {
    return t(`passagensPage.${i18nKey}`, { defaultValue: humanizeToken(key) });
  }
  return t("passagensPage.paymentProvider_generic", {
    defaultValue: humanizeToken(key) || "Pagamento",
  });
}

export function formatPaymentEventPrimary(t, payment) {
  const eventLabel = paymentEventTypeLabel(t, payment?.event_type);
  const providerLabel = paymentProviderLabel(t, payment?.provider);
  return `${eventLabel} · ${providerLabel}`;
}

export function formatPaymentEventSecondary(t, payment, { fmtMoney, fmtDateTime } = {}) {
  const parts = [];
  if (payment?.amount != null && typeof fmtMoney === "function") {
    parts.push(fmtMoney(payment.amount));
  }
  const txId = payment?.mp_payment_id != null ? String(payment.mp_payment_id).trim() : "";
  if (txId) {
    parts.push(
      t("passagensPage.paymentEventTransaction", {
        id: txId,
        defaultValue: `Transação ${txId}`,
      })
    );
  }
  if (payment?.created_at && typeof fmtDateTime === "function") {
    parts.push(fmtDateTime(payment.created_at));
  }
  return parts.filter(Boolean).join(" · ") || "—";
}
